import * as React from 'react';
import { Box, Thumbnail, TextButton, Text } from '@wix/design-system';
import { RefreshSmall } from '@wix/wix-ui-icons-common';
import s from './ChoosePlanName.scss';
export const ChoosePlanName = _ref => {
  let {
    data: {
      planNames
    },
    context: {
      send,
      onWidgetAction
    }
  } = _ref;
  const regenerate = React.useCallback(() => {
    send('Regenerate please');
    onWidgetAction(PRICING_PLANS_CHOOSE_NAME, {
      action: 'regenerate'
    });
  }, [send, onWidgetAction]);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 2,
    paddingTop: "SP1",
    paddingBottom: "SP1",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, "Choose a plan name"), planNames.map((name, index) => /*#__PURE__*/React.createElement(PlanName, {
    key: index,
    name: name,
    send: send,
    onWidgetAction: onWidgetAction
  })), /*#__PURE__*/React.createElement(Box, {
    paddingTop: "SP2"
  }, /*#__PURE__*/React.createElement(TextButton, {
    onClick: regenerate,
    prefixIcon: /*#__PURE__*/React.createElement(RefreshSmall, null),
    size: "tiny",
    className: s.icon
  }, "Create Again")));
};
const PlanName = /*#__PURE__*/React.memo(_ref2 => {
  let {
    name,
    send,
    onWidgetAction
  } = _ref2;
  const pickPlanName = () => {
    onWidgetAction(PRICING_PLANS_CHOOSE_NAME, {
      action: 'choose',
      value: name
    });
    send(`I'll go with "${name}".`);
  };
  return /*#__PURE__*/React.createElement(Thumbnail, {
    className: s.buttonWrapper,
    onClick: pickPlanName
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "SP2"
  }, /*#__PURE__*/React.createElement(Text, {
    skin: "primary",
    size: "small"
  }, name)));
});
export const PRICING_PLANS_CHOOSE_NAME = 'PRICING_PLANS_CHOOSE_NAME';
//# sourceMappingURL=ChoosePlanName.js.map